import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Parking = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 3H12.29C15.34 3 18.06 5.19 18.45 8.21C18.92 11.87 16.07 15 12.5 15H9.5V19C9.5 20.1 8.6 21 7.5 21C6.4 21 5.5 20.1 5.5 19V5C5.5 3.9 6.4 3 7.5 3ZM9.5 11H12.7C13.8 11 14.7 10.1 14.7 9C14.7 7.9 13.8 7 12.7 7H9.5V11Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Parking;
